import { FC } from 'react'
import PageLayout from '../../components/page-layout/page-layout'
import ProfileHeader from './components/profile-header/profile-header'
import useProfileUser from './hooks/use-profile-user'

const ProfilePage: FC = () => {
    const { userId, username, phoneNumber, positionName, positionComponents } = useProfileUser()

    return (
        <PageLayout title='Профиль' scrollableContent>
            <ProfileHeader
                userId={userId}
                username={username}
                phoneNumber={phoneNumber}
                positionName={positionName}
            />

            {positionComponents.map(Component => <Component key={Component.name} />)}
        </PageLayout>
    )
}

export default ProfilePage
